/*
 * ============================================================
 * argile-product-tabs.js — onglets horizontaux (Détails / Livraison / Retours)
 * ============================================================
 * Convention Argile : « 1 section = son JS ». Chargé PAR
 * `sections/argile-product-tabs.liquid`.
 *
 * Cible `[data-argile-product-tabs]`. Au clic (ou flèches gauche/droite) sur un
 * onglet `[role="tab"]`, affiche le panneau `[data-tab-panel]` correspondant et,
 * si l'onglet porte une `data-tab-image`, alimente l'image de gauche
 * `[data-tab-stage]` (cross-fade via `.is-ready`).
 *
 * Idempotent + ré-init sur `shopify:section:load`. Réagit à
 * `shopify:block:select` (éditeur) pour activer l'onglet sélectionné.
 */
(function () {
  'use strict';

  function initTabs(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-argile-product-tabs]').forEach(function (group) {
      if (group.dataset.argileWired) return;
      group.dataset.argileWired = '1';

      var stage = group.querySelector('[data-tab-stage]');
      var defaultImg = group.dataset.defaultImage || '';
      var tabs = [].slice.call(group.querySelectorAll('[role="tab"]'));
      var panels = [].slice.call(group.querySelectorAll('[data-tab-panel]'));
      if (!tabs.length) return;

      function setStage(src, alt) {
        if (!stage) return;
        var next = src || defaultImg;
        if (!next || stage.getAttribute('src') === next) return;
        stage.classList.remove('is-ready');
        var pre = new Image();
        pre.onload = function () {
          stage.src = next;
          if (alt != null) stage.alt = alt;
          stage.classList.add('is-ready');
        };
        pre.src = next;
      }

      function activate(index, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
          panel.hidden = i !== index;
        });
        var active = tabs[index];
        setStage(active.getAttribute('data-tab-image'), active.getAttribute('data-tab-alt'));
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i, false); });
      });

      group.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var current = tabs.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        var next = event.key === 'ArrowRight'
          ? (current + 1) % tabs.length
          : (current - 1 + tabs.length) % tabs.length;
        activate(next, true);
      });

      // Éditeur de thème : sélectionner un block ouvre son onglet.
      group.addEventListener('shopify:block:select', function (event) {
        var panel = event.target.closest('[data-tab-panel]');
        if (!panel) return;
        var i = panels.indexOf(panel);
        if (i >= 0) activate(i, false);
      });

      activate(0, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTabs(document); });
  } else {
    initTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTabs(event.target);
  });
})();
